import { render } from "./PlanAndBilling.vue?vue&type=template&id=15e8017b&scoped=true"
import script from "./PlanAndBilling.vue?vue&type=script&lang=js"
export * from "./PlanAndBilling.vue?vue&type=script&lang=js"

import "./PlanAndBilling.vue?vue&type=style&index=0&id=15e8017b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e8017b"]])

export default __exports__